import { makeStyles } from '@material-ui/core/styles';
import { Link, Button } from '@/components/global';

const useStyles = makeStyles(({ breakpoints: BP }) => ({
  col: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    color: '#303235',
    paddingRight: 50,
    '& h1': {
      fontSize: 30,
      fontWeight: 'bold',
    },
    '& h3': {
      fontSize: 14,
      fontWeight: 300,
      textAlign: 'justify',
      lineHeight: 1.36,
    },
    [BP.between('xs', 'md')]: {
      padding: 0,
      '& h1': {
        fontSize: 20,
      },
    },
  },
  row: {
    display: 'flex',
    direction: 'rtl',
    flex: 1,
    margin: '0 20px',
    [BP.between('xs', 'md')]: {
      flexDirection: 'column',
      margin: '0 5px',
    },
  },

  img: {
    borderRadius: 20,
    objectFit: 'cover',
    height: 375,
    width: '100%',
    [BP.between('xs', 'md')]: {
      minHeight: '30vh',
      height: '30vh',
      borderRadius: 10,
    },
  },
  butCont: {
    marginTop: 40,
    display: 'flex',
    justifyContent: 'flex-end',
    [BP.between('xs', 'md')]: {
      justifyContent: 'center',
      margin: '15px 0',
    },
  },
  flex: {
    flex: 1,
    display: 'flex',
  },
}));

export default function ContestCard() {
  const cls = useStyles();
  return (
    <div className={cls.row}>
      <div className={cls.flex}>
        <img className={cls.img} src="/images/landing/video.png" />
      </div>
      <div className={cls.col}>
        <div className={cls.headerRow}>
          <h1>مسابقه طراحی مبلمان دکوژ</h1>
        </div>
        <h3>
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
          استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
          ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و
          کاربردهای متنوع با هدف بهبود ابزار طراحان رایانه
        </h3>
        <div className={cls.butCont}>
          <Link href="/merchant/signUp">
            <Button className={cls.but2}>شرکت در مسابقه</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
